import { 
    Card, 
    CardBody, 
    CardButtons, 
    CardGrid, 
    CardGridAmount, 
    CardGridItem, 
    CardHeader, 
    CardSubtitle, 
    CardTitle, 
    DetailsButton,
} from 'components';
import { formatDate } from 'functions';
import { useNavigation } from 'hooks';
import { PaymentDetail } from 'types';
import styles from './DeductionCard.module.scss';

type Props = {
    payment: PaymentDetail
}

export default function DeductionCard({ payment }: Props) {
    const {
        adjustmentAmount,
        customerName,
        customerId,
        customerItemReference,
        invoiceDate,
        invoiceId,
        vendorId,
        accountId,
    } = payment; 
    const { navigateToDeduction } = useNavigation();

    return (
        <Card className={styles.card}>
            <CardHeader className={styles.header}>
                <div className={styles.division}>
                    <CardTitle>
                        <span>Customer Deduction {invoiceId}</span>
                    </CardTitle>
                    <CardSubtitle className={styles.subtitle}>
                        <span><strong>Vendor ID</strong>: &nbsp;{vendorId || 'Not Found'}</span>
                        <span><strong>Date</strong>: &nbsp;{invoiceDate ? formatDate(invoiceDate) : 'Not Found'}</span>
                    </CardSubtitle>
                </div>
            </CardHeader>
            <CardBody>
                <CardGrid className={styles.grid}>
                    <CardGridItem label="Customer Number" value={customerId ? Number(customerId) : 0} />
                    <CardGridItem label="Customer Name" value={customerName} />
                    <CardGridItem label="Reference Number" value={customerItemReference} />
                    <CardGridAmount label="Amount" value={adjustmentAmount} />
                </CardGrid>
                <CardButtons>
                    <DetailsButton onClick={() => navigateToDeduction(accountId as string, vendorId as string, invoiceId as string, customerItemReference as string)} />
                </CardButtons>
            </CardBody>
        </Card>
    );
}